var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpades(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "rotate(225,30,30)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    x: 20,
    y: 20
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 35,
    r: 15
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 35,
    cy: 20,
    r: 15
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30,30 Q30,50 20,60 H40 Q30,50 30,30"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpades);
export default __webpack_public_path__ + "static/media/spades.3f5c7c74430e3f2ec5eb7494d218fb8b.svg";
export { ForwardRef as ReactComponent };